import { getHttpClient } from '../axiosInstance'

const base = '/admin/language-pairs/v1'

export const fetchWithPagination = async (queryParams) => {
  const apiClient = getHttpClient()
  const url = `${base}/`
  /**
   * Add hidden parameters to make the API call
   */
  const hiddenParams = {}

  /**
   * It's also possible to remove and sanitize some parameters
   */
  const customQueryParams = { ...queryParams, ...hiddenParams }

  const response = await apiClient.get(url, { params: customQueryParams })
  return response.data
}

export const toggle = async (id) => {
  const apiClient = getHttpClient()

  const url = `${base}/toggle/${id}`
  const response = await apiClient.put(url, {})
  return response.data
}

export const remove = async (id) => {
  const apiClient = getHttpClient()

  const url = `${base}/${id}`
  const response = await apiClient.delete(url, {})
  return response.data
}

export const load = async (id) => {
  const apiClient = getHttpClient()
  const url = `${base}/${id}`

  const response = await apiClient.get(url)
  return response.data
}

export const create = async (form) => {
  const apiClient = getHttpClient()
  const url = `${base}/form`

  const response = await apiClient.post(url, form)
  return response.data
}

export const update = async (id, form) => {
  const apiClient = getHttpClient()
  const url = `${base}/form/${id}`

  const response = await apiClient.put(url, form)
  return response.data
}
